import Autocomplete from "react-google-autocomplete";
import { GoogleMap, Marker } from "@react-google-maps/api";
import React, { useRef, useState } from "react";

const LocationPicker = ({
  onLocationSelect,
  pickLocation,
  apiKey,
  handleClose,
}) => {
  const mapRef = useRef(null);
  const [selectedPosition, setSelectedPosition] = useState(pickLocation);
  const [zoom, setZoom] = useState(10);

  const handleMapClick = (event) => {
    setSelectedPosition({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };

  const handleOnPlaceSelected = (place) => {
    if (!place.geometry || !place.geometry.location) {
      return;
    }

    const newPosition = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    setSelectedPosition(newPosition);
    mapRef.current.panTo(newPosition);
    mapRef.current.setZoom(15);
  };
  return (
    <>
      <div className="ui card" style={{ width: "100%" }}>
        <Autocomplete
          apiKey={apiKey}
          onPlaceSelected={handleOnPlaceSelected}
          options={{
            types:[],
          }}
          style={{
            width: "100%",
            height: "40px",
            zIndex: 1050,
          }}
          placeholder="Search places..."
        />
        <GoogleMap
          mapContainerStyle={{
            width: "100%",
            height: "500px",
          }}
          center={selectedPosition}
          zoom={zoom}
          onClick={handleMapClick}
          onLoad={(map) => (mapRef.current = map)}
        >
          <Marker position={selectedPosition} />
        </GoogleMap>

        <div className="extra content right aligned">
          <button
            className="ui primary button"
            onClick={() => onLocationSelect(selectedPosition)}
          >
            Save
          </button>
          <button className="ui secondary button" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default LocationPicker;
